<!--  Wrapped the entire page content inside <main> landmark for better semantic structure -->
  <section>
    <!--  Added a visually clear <h1> as main heading at the top of the page -->
    <h1 class="sr-only">Applicant List</h1>
      <div class="root-container" *ngIf="!isAddEditApplicantAllowed">
      <div class="search-container">
        <div class="search-bar">
          <i class="fa-solid fa-magnifying-glass search-icon" aria-hidden="true"></i>
          <input
            type="text"
            [(ngModel)]="searchTerm"
            (input)="onSearch($event)"
            placeholder="Search applicants..."
            aria-label="Search applicants"
          />
          <button *ngIf="searchTerm" class="clear-btn" (click)="clearSearch()" aria-label="Clear Search">
            <i class="fa-solid fa-circle-xmark"></i>
          </button>
        </div>
      </div>
  
      <div class="overlay" *ngIf="isLoading"></div>
      <div class="d-flex justify-content-center" *ngIf="isLoading">
        <div class="spinner-border loading-indicator" style="color: #2730E3;width: 3rem; height: 3rem;" role="status" aria-live="polite">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div class="user-container mat-elevation-z3" *ngIf="!isLoading">
        <app-eg-table
          *ngIf="applicants.length>0"
          [data]="applicants" [start]="start" [end]="end" [pageSize]="pageSize"
          [totalElements]="totalElements" [pageIndex]="pageIndex"
          [columns]="displayedColumns" [columnKeyValues]="cols" [serverSidePagination]="true"
          (pageEvent)="getPaginatorData($event)" (btnClicked)="profileActions($event)"
          [showSortIcon]="false"
          [moduleName]="'applicant-list'" [isAddEditApplicantAllowed]="isAddEditApplicantAllowed"
        >
          <!--  Added table caption for screen readers -->
          <caption class="sr-only">List of applicants with pagination and actions</caption>
        </app-eg-table>
        <div class="applicant-container" *ngIf="applicants && applicants?.length === 0">
          <p>No applicants to display.</p>
        </div>
      </div>
    </div>
      <div class="root-container" *ngIf="isAddEditApplicantAllowed">
        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" (selectedTabChange)="tabChanged($event)" [(selectedIndex)]="selectedTabIndex">
          <mat-tab [label]="tabNames[0]">
            <!-- Added <section> for Applicant List tab for better semantics -->
            <section aria-labelledby="applicant-list-heading">
              <h2 id="applicant-list-heading" class="sr-only">Applicant List</h2>
              <div class="search-container">
                <div class="search-bar">
                  <i class="fa-solid fa-magnifying-glass search-icon" aria-hidden="true"></i>
                  <input
                    type="text"
                    [(ngModel)]="searchTerm"
                    (input)="onSearch($event)"
                    placeholder="Search applicants..."
                    aria-label="Search applicants"
                  />
                  <button *ngIf="searchTerm" class="clear-btn" (click)="clearSearch()" aria-label="Clear Search">
                    <i class="fa-solid fa-circle-xmark"></i>
                  </button>
                </div>
              </div>
    
              <div class="overlay" *ngIf="isLoading"></div>
              <div class="d-flex justify-content-center" *ngIf="isLoading">
                <div class="spinner-border loading-indicator" style="color: #2730E3;width: 3rem; height: 3rem;" role="status"aria-live="polite">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
                <div class="user-container mat-elevation-z3" *ngIf="!isLoading">
                  <app-eg-table
                    *ngIf="applicants.length>0"
                    [data]="applicants" [start]="start" [end]="end" [pageSize]="pageSize"
                    [totalElements]="totalElements" [pageIndex]="pageIndex"
                    [columns]="displayedColumns" [columnKeyValues]="cols" [serverSidePagination]="true"
                    (pageEvent)="getPaginatorData($event)" (btnClicked)="profileActions($event)"
                    [showSortIcon]="false" [isAddEditApplicantAllowed]="isAddEditApplicantAllowed"
                  >
                    <!-- Added caption for screen readers -->
                    <caption class="sr-only">List of applicants with pagination and actions</caption>
                  </app-eg-table>
                <div class="applicant-container" *ngIf="applicants && applicants?.length === 0">
                  <p>No applicants to display.</p>
                </div>
              </div>
            </section>
          </mat-tab>

          <mat-tab [label]="tabNames[1]">
            <!-- Added <section> for Add Applicant tab -->
            <section aria-labelledby="add-applicant-heading">
              <h2 id="add-applicant-heading" class="sr-only">Add Applicant</h2>
    
              <div class="search-container row" *ngIf="isEligibilityAutoDetermined">
                <div class="search-bar col-md-6">
                  <i class="fa-solid fa-magnifying-glass search-icon"></i>
                  <input
                    matInput
                    type="text"
                    [(ngModel)]="searchPID"
                    placeholder="Search PID for applicants..."
                    aria-label="Search PID for applicants"
                  />
                  <button *ngIf="searchPID" class="clear-btn" (click)="clearPIDSearch()" aria-label="Clear PID Search">
                    <i class="fa-solid fa-circle-xmark" aria-hidden="true"></i>
                  </button>
                </div>
                <div class="col-md-5">
                  <button class="button-default custom-btn-primary" *ngIf="isEligibilityAutoDetermined" [disabled]="searchPID==''" [attr.aria-disabled]="searchPID==''" (click)="getApplicantData()">
                    Get Applicant Data
                  </button>
                  <button class="button-default custom-btn-primary" style="margin-left: 10px;" (click)="openDialog()">
                    <i class="fa-solid fa-upload" aria-hidden="true"></i>&nbsp;
                    Upload XLSX File
                  </button>
                </div>
                <!-- Fields mapping
                    First Name : first_name
                    Middle Name: middle_name_initials
                    Last Name: last_name
                    Gender: gender
                    Date Of Birth: date_of_birth

                    Primary Phone Number: extra7
                    Alternate Phone Number: phone_mobile
                    Email Address: extra8
                    Address: home_street
                    City: home_city
                    State: home_state
                    Zipcode: home_postcode

                    Address: mailing_street
                    City: mailing_city
                    State: mailing_state
                    Zipcode: mailing_postcode

                    Personal ID(PID): extra2
                    SIS ID: extra3
                    Last 4 of Social: SSN4
                    Medicaid: medicaid_number

                    Home County: home_county
                    Race: race
                    Ethnicity: ethnicity
                    Marital Status: marital_status
                    Preferred Language: preferred_language

                    Name: emergency_contact
                    Primary Phone Number: emergency_phone_day


                    Extra Fields ,not in form UI
                      email
                      extra1
                      extra4
                      extra5
                      extra6
                      home_street_suffix
                      mecklenburg_customer_id
                      mailing_county
                      mailing_directions
                      mailing_comments
                      mailing_unit_type
              -->
              </div><br>
              <div class="note-and-upload-button" *ngIf="!isEligibilityAutoDetermined">
                <span class="mb-0">
                  Note: Fields marked with <span class="note-text">*</span> are mandatory
                </span>
                <button
                  class="button-default custom-btn-primary"
                  (click)="openDialog()"
                  aria-label="Upload XLSX File"
                >
                  <i class="fa-solid fa-upload" aria-hidden="true"></i>&nbsp;
                  Upload XLSX File
                </button>
              </div>
              <form [formGroup]="addApplicantForm" (ngSubmit)="addApplicant()">
                <div class="overlay" *ngIf="isLoading"></div>
                <div class="d-flex justify-content-center" *ngIf="isLoading">
                  <div class="spinner-border loading-indicator" style="color: #2730E3;width: 3rem; height: 3rem;" role="status"aria-live="polite">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
                <p *ngIf="isEligibilityAutoDetermined" class="note-text-two">Note: Fields marked with <span class="note-text">*</span> are mandatory</p>
                <mat-card *ngFor="let section of sections" appearance="outlined" class="section-card">
                  <mat-card-header>
                    <mat-card-title>{{section.name}}</mat-card-title>
                  </mat-card-header>
                  <mat-card-content>
                    <div class="addApplicantCard">
                      <div *ngFor="let field of section.fields">
                        <div class="marLeft">
                          <ng-container *ngIf="field.type=='text'">
                          <mat-form-field appearance="outline" class="material-field">
                            <mat-label>{{field.label}}<span style="color:#ea4848;font-size: 16px;" *ngIf="field.required">*</span></mat-label>
                            <input
                              matInput
                              type="text"
                              id="{{field.control_name}}"
                              formControlName="{{field.control_name}}"
                              [attr.name]="field.control_name"
                              [pattern]="field.pattern ? field.pattern : ''"
                              maxlength="{{field.maxlength}}"
                              (keypress)="(field.pattern === '^[0-9]+$' || field.pattern === '^\\d+$') ? allowOnlyNumbers($event) : null"
                              (input)="onNumberInput($event, field.control_name)"
                              [ngClass]="field.control_name=='extra2' && addApplicantForm.controls['extra2'].disabled ? 'disabled-state' : ''"
                            />
                            <ng-container *ngIf="field.control_name=='extra2' || field.control_name=='extra3' || field.control_name=='SSN4'">
                              <i
                                class="eye-icon"
                                (click)="togglePasswordVisibility(field.control_name)"
                                (keydown)="togglePasswordVisibility(field.control_name)"
                                [ngClass]="showPassword[field.control_name] ? 'fa fa-eye-slash' : 'fa fa-eye'"
                                aria-hidden="true"
                              ></i>
                            </ng-container>
                          </mat-form-field>
                        </ng-container>
                        <ng-container *ngIf="field.type=='longtext'">
                          <mat-form-field appearance="outline" class="material-field long-text-field">
                            <mat-label>{{field.label}}<span style="color:#ea4848;font-size: 16px;" *ngIf="field.required">*</span></mat-label>
                            <input
                              matInput
                              type="text"
                              id="{{field.control_name}}"
                              formControlName="{{field.control_name}}"
                              [attr.name]="field.control_name"
                              maxlength="{{field.maxlength}}"
                            />
                          </mat-form-field>
                        </ng-container>
                        <ng-container *ngIf="field.type=='select'">
                          <mat-form-field appearance="outline" class="material-field">
                            <mat-label>{{field.label}}<span style="color:#ea4848;font-size: 16px;" *ngIf="field.required">*</span></mat-label>
                            <mat-select
                              id="{{field.control_name}}"
                              formControlName="{{field.control_name}}"
                              [attr.name]="field.control_name"
                            >
                              <mat-option value="">---Select---</mat-option>
                              <mat-option *ngFor="let option of field.options" [value]="option.key">{{option.value}}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </ng-container>

                        <!-- Date Picker Field -->
                        <ng-container *ngIf="field.type=='datepicker'">
                          <mat-form-field appearance="outline"  class="material-field date-field">
                            <mat-label>
                                {{field.label | slice:0:13 }}{{ field.label.length > 13 ? '...' : '' }}                              <span style="color:#ea4848;font-size: 16px;">*</span></mat-label>
                            <input
                              matInput
                              [matDatepicker]="basicDatepicker"
                              [formControlName]="field.control_name"
                              [max]="maxDate"
                              [min]="minDate"
                              [attr.name]="field.control_name"
                              placeholder="MM/DD/YYYY"
                            />
                            <mat-datepicker-toggle [for]="basicDatepicker"></mat-datepicker-toggle>
                            <mat-datepicker #basicDatepicker></mat-datepicker>
                          </mat-form-field>
                        </ng-container>
                        <!-- Validation Messages -->
                          <div *ngIf="field.type!='select' && field.control_name!='date_of_birth' && addApplicantForm.get(field.control_name)?.touched && addApplicantForm?.get(field.control_name)?.errors?.['required']" style="color:red">
                            Please enter {{field.label}}
                        </div>
                        <div *ngIf="field.type!='select' && field.control_name=='date_of_birth' && addApplicantForm.get(field.control_name)?.touched && addApplicantForm?.get(field.control_name)?.errors?.['required']" style="color:red">
                          Please enter Date of Birth
                        </div>
                        <div *ngIf="field.type=='select' && addApplicantForm.get(field.control_name)?.touched && addApplicantForm?.get(field.control_name)?.errors?.['required']" style="color:red">
                          Please select {{field.label}}
                        </div>
                        <div *ngIf="addApplicantForm.get(field.control_name)?.touched && addApplicantForm?.get(field.control_name)?.errors?.['pattern']" style="color:red;width: 250px">
                          <div *ngIf="field.control_name == 'contact_primary_phone_number' || field.control_name == 'contact_alternate_phone_number' 
                          || field.control_name == 'emergency_primary_phone_number' || field.control_name == 'extra7' || field.control_name == 'phone_mobile'
                          || field.control_name == 'emergency_phone_day' || field.control_name == 'phone_landline'">Please enter 10 digit phone number in format XXX-XXX-XXXX</div>
                          <div *ngIf="field.control_name != 'contact_primary_phone_number' && field.control_name != 'contact_alternate_phone_number' 
                          && field.control_name != 'emergency_primary_phone_number' && field.control_name != 'extra7' && field.control_name != 'phone_mobile'
                          && field.control_name != 'emergency_phone_day' && field.control_name != 'extra2' && field.control_name != 'phone_landline'">Please enter valid {{field.label}}</div>
                          <div *ngIf="field.control_name == 'extra2'">Special characters are not allowed</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </mat-card-content>
                </mat-card>
                <br />
                <div class="form-buttons">
                  <button class="button-default custom-btn-primary" type="submit" [disabled]="!addApplicantForm.valid">Submit</button>
                  <button class="button-default custom-btn-primary" type="reset" style="margin-left: 10px;" (click)="resetApplicantData()">Clear Data</button>
                </div>
              </form>
            </section>
          </mat-tab>
        </mat-tab-group>
    </div>
  </section>